/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DjRestAuthUser } from '../models/DjRestAuthUser';
import type { InvitationRead } from '../models/InvitationRead';
import type { InvitationWrite } from '../models/InvitationWrite';
import type { PaginatedInvitationReadList } from '../models/PaginatedInvitationReadList';
import type { PatchedInvitationWrite } from '../models/PatchedInvitationWrite';
import type { UserRegistrationWithInvitation } from '../models/UserRegistrationWithInvitation';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InvitationService {

    /**
     * CRUD endpoints for pending invitations.
     *
     * Inherits security-context scoping from ``SecurityContextMixin`` (HCE reps
     * see their org; staff see everything cross-org). ``retrieve`` is the
     * exception — it preserves the legacy public ``[AllowAny, CanEditInvitation]``
     * behavior so unauthenticated callers can fetch an invitation by pk.
     * Other actions are gated by ``MemberHasPermission`` against the
     * ``{read,create,update,delete}__accounts__invitation`` codes.
     * @returns PaginatedInvitationReadList
     * @throws ApiError
     */
    public static invitationList({
        groupNamesIn,
        healthcareEntityId,
        limit,
        offset,
        ordering,
        roleIn,
        search,
    }: {
        groupNamesIn?: Array<string>,
        healthcareEntityId?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `ADMIN` - Administrator
         * * `RECRUIT` - Recruiter
         * * `SCHED` - Scheduler
         * * `COMMON` - Common
         */
        roleIn?: Array<'ADMIN' | 'COMMON' | 'RECRUIT' | 'SCHED'>,
        search?: string,
    }): CancelablePromise<PaginatedInvitationReadList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/invitation/',
            query: {
                'group_names__in': groupNamesIn,
                'healthcare_entity_id': healthcareEntityId,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'role__in': roleIn,
                'search': search,
            },
        });
    }

    /**
     * CRUD endpoints for pending invitations.
     *
     * Inherits security-context scoping from ``SecurityContextMixin`` (HCE reps
     * see their org; staff see everything cross-org). ``retrieve`` is the
     * exception — it preserves the legacy public ``[AllowAny, CanEditInvitation]``
     * behavior so unauthenticated callers can fetch an invitation by pk.
     * Other actions are gated by ``MemberHasPermission`` against the
     * ``{read,create,update,delete}__accounts__invitation`` codes.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationCreate({
        requestBody,
    }: {
        requestBody: InvitationWrite,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/invitation/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * CRUD endpoints for pending invitations.
     *
     * Inherits security-context scoping from ``SecurityContextMixin`` (HCE reps
     * see their org; staff see everything cross-org). ``retrieve`` is the
     * exception — it preserves the legacy public ``[AllowAny, CanEditInvitation]``
     * behavior so unauthenticated callers can fetch an invitation by pk.
     * Other actions are gated by ``MemberHasPermission`` against the
     * ``{read,create,update,delete}__accounts__invitation`` codes.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/invitation/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * CRUD endpoints for pending invitations.
     *
     * Inherits security-context scoping from ``SecurityContextMixin`` (HCE reps
     * see their org; staff see everything cross-org). ``retrieve`` is the
     * exception — it preserves the legacy public ``[AllowAny, CanEditInvitation]``
     * behavior so unauthenticated callers can fetch an invitation by pk.
     * Other actions are gated by ``MemberHasPermission`` against the
     * ``{read,create,update,delete}__accounts__invitation`` codes.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: InvitationWrite,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/invitation/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * CRUD endpoints for pending invitations.
     *
     * Inherits security-context scoping from ``SecurityContextMixin`` (HCE reps
     * see their org; staff see everything cross-org). ``retrieve`` is the
     * exception — it preserves the legacy public ``[AllowAny, CanEditInvitation]``
     * behavior so unauthenticated callers can fetch an invitation by pk.
     * Other actions are gated by ``MemberHasPermission`` against the
     * ``{read,create,update,delete}__accounts__invitation`` codes.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationPartialUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PatchedInvitationWrite,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/invitation/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * CRUD endpoints for pending invitations.
     *
     * Inherits security-context scoping from ``SecurityContextMixin`` (HCE reps
     * see their org; staff see everything cross-org). ``retrieve`` is the
     * exception — it preserves the legacy public ``[AllowAny, CanEditInvitation]``
     * behavior so unauthenticated callers can fetch an invitation by pk.
     * Other actions are gated by ``MemberHasPermission`` against the
     * ``{read,create,update,delete}__accounts__invitation`` codes.
     * @returns void
     * @throws ApiError
     */
    public static invitationDestroy({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/invitation/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * CRUD endpoints for pending invitations.
     *
     * Inherits security-context scoping from ``SecurityContextMixin`` (HCE reps
     * see their org; staff see everything cross-org). ``retrieve`` is the
     * exception — it preserves the legacy public ``[AllowAny, CanEditInvitation]``
     * behavior so unauthenticated callers can fetch an invitation by pk.
     * Other actions are gated by ``MemberHasPermission`` against the
     * ``{read,create,update,delete}__accounts__invitation`` codes.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationResendUpdate({
        id,
    }: {
        id: string,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/invitation/{id}/resend',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Anonymous token-based invitation retrieval used by the invitation
     * acceptance flow.  Permission scoping deliberately does NOT use
     * ``SecurityContextMixin`` — this endpoint is unauthenticated.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationFromTokenRetrieve({
        token,
    }: {
        token: string,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/invitation/from-token/{token}/',
            path: {
                'token': token,
            },
        });
    }

    /**
     * @returns DjRestAuthUser
     * @throws ApiError
     */
    public static invitationRegisterCreate({
        requestBody,
    }: {
        requestBody: UserRegistrationWithInvitation,
    }): CancelablePromise<DjRestAuthUser> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/invitation/register/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
